export function contactFullName(
  contact:
    | {
        name?: string | null
        legalName?: string | null
      }
    | null
    | undefined
) {
  const { name, legalName } = contact ?? {}
  if (!name) return legalName ?? '-'
  if (!legalName) return name ?? '-'
  return name !== legalName ? `${legalName} (${name})` : name
}
